var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    width: 23.2727,
    height: 23.2727,
    rx: 6,
    fill: "#FBF5ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15799_8715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3266 9.72736H14.3148V6.54554C14.3148 6.19554 14.0284 5.90918 13.6784 5.90918H11.133C10.783 5.90918 10.4966 6.19554 10.4966 6.54554V9.72736H9.48481C8.91844 9.72736 8.63208 10.4146 9.03299 10.8155L11.9539 13.7365C12.2021 13.9846 12.603 13.9846 12.8512 13.7365L15.7721 10.8155C16.173 10.4146 15.893 9.72736 15.3266 9.72736ZM7.95117 16.091C7.95117 16.441 8.23754 16.7274 8.58754 16.7274H16.2239C16.5739 16.7274 16.8603 16.441 16.8603 16.091C16.8603 15.741 16.5739 15.4546 16.2239 15.4546H8.58754C8.23754 15.4546 7.95117 15.741 7.95117 16.091Z",
    fill: "black",
    fillOpacity: 0.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15799_8715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2727,
    height: 15.2727,
    fill: "white",
    transform: "translate(4.76953 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.18f63758eff63d2fee75909da0f082fb.svg";
export { ForwardRef as ReactComponent };